require('./bootstrap');

window.Vue = require('vue');

import Vue                       from 'vue';
import VueSweetalert2            from 'vue-sweetalert2';
import { VTooltip, VPopover }    from 'v-tooltip'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.directive('tooltip', VTooltip);
Vue.component('v-popover', VPopover);

Vue.use(VueSweetalert2);
Vue.use(vueNumeralFilterInstaller);

const app = new Vue({
    el: '#calculator',
    data: {
        input: {
            terms: 52,
            cash: 0,
        },
        globals: {
            flat_rate: 0,
            arrangement_fee: 0,
        },
        terms: [],
        appUrl: process.env.MIX_APP_URL,
        post_url: '',
        product_id: 0,
        product: '',
        styles: [],
        combinations: [],
        swatchNotSelected: true,
        combinationSelected: false,
        sofaSelection: {
            swatch: {
                id: 0,
                product_id: 0,
                style_id: 0,
                image_path: '',
                title: '',
            },
            style: {
                id: 0,
                product_id: 0,
                title: '',
            },
        },
        baseTypes: [],
        bedSelection: {
            bedBaseNotSelected: true,
            bedBase: {},
            storageNotSelected: true,
            storage: {},
            mattressNotSelected: true,
            mattress: {},
            headboardNotSelected: true,
            headboard: {},
            swatchNotSelected: true,
            swatch: {},
        },
        product_attributes: [],
        product_subitems: [],
        originalPrice: '',
        stock_status_id: null,
        voucherPricing: [
            {
                id: null,
                product_id: null,
                attribute_id: null,
                title: null,
                cash_price: null,
                created_at: null,
                updated_at: null,
            }],
    },
    methods: {
        calculate_apr(terms, rate) {
            var weeks = [];

            // Fill in the weeks
            // for (var week = 0; week < 105; week++) {
            //     weeks[week] = 0;
            // }

            for (var week = 0; week < terms; week++) {
                weeks[week] = 100 * (1 + rate) / terms;
            }

            var irr = this.calculate_irr(100, weeks);
            var apr = Math.pow(irr + 1, 52) - 1;

            return (apr);
        },
        calculate_irr(investment, flow) {
            for (var n = 0; n < 100; n += 0.000001) {
                var pv = 0;

                for (var i = 0; i < flow.length; i++) {
                    pv = pv + flow[i] / Math.pow(1 + n, i + 1);
                }

                if (pv <= investment) {
                    return n;
                }
            }
        },
        calculate_deposit(product, cash) {
            let deposit = (Math.round((cash * 0.05) / 5) * 5);

            switch (product) {
                case 'car':
                    deposit = (Math.round((cash * 0.07) / 5) * 5);
                    break;

                case 'carpet':
                case 'blinds':
                case 'voucher':
                    deposit = 0;
                    break;
            }

            return deposit;
        },
        calculate_loan_details(terms, product) {
            var flat_rate       = 19;
            var arrangement_fee = 40;

            if (product === 'retail' || product === 'sofa' || product === 'bed'|| product === 'carpet' || product === 'blinds') {
                // Figure out the rate of interest
                if (terms >= 52) {
                    flat_rate       = 36;
                    arrangement_fee = 25;
                } else if (terms >= 39) {
                    flat_rate       = 27;
                    arrangement_fee = 20;
                } else if (terms >= 26) {
                    flat_rate       = 18
                    arrangement_fee = 20;
                } else {
                    flat_rate       = 15;
                    arrangement_fee = 15;
                }

                if (product === 'carpet' || product === 'blinds') {
                    arrangement_fee = 0;
                }
            } else if (product === 'voucher' || product === 'experience') {
                arrangement_fee = 0;

                if (terms === 52) {
                    flat_rate = 80;
                } else if (terms > 38) {
                    flat_rate = 60;
                } else if (terms > 25) {
                    flat_rate = 40;
                } else {
                    flat_rate = 20;
                }
            }

            this.globals.flat_rate       = flat_rate;
            this.globals.arrangement_fee = 0; //Disabled arrangement_fee as per easybuys request
        },
        getTerms(product) {
            switch (product) {
                case 'retail':
                case 'carpet':
                case 'blinds':
                    this.terms       = [26, 52, 78, 104];
                    this.input.terms = 104;
                    break;

                case 'bed':
                    this.terms       = [13, 26, 39, 52, 78, 104];
                    this.input.terms = 104;
                    break;

                case 'car':
                    this.terms       = [52, 104, 156];
                    this.input.terms = 156;
                    break;

                case 'voucher':
                case 'experience':
                    this.terms       = [13, 26, 39, 52];
                    this.input.terms = 52;
                    break;

                default:
                    this.terms       = [13, 26, 39, 52, 78, 104, 156];
                    this.input.terms = 156;
                    break;
            }
        },
        addToCart(input, interest) {
            let data       = {};
            let errors     = [];
            let errorText  = '';
            let canProceed = true;

            if ($('.product-wrapper').data('is-range')) {
                if (!$('.subitems-list').find('input:checked').length) {
                    canProceed = false;

                    this.$swal.fire({
                        title: 'No products chosen!',
                        text: 'Please choose your products to continue.',
                        icon: 'error',
                    });
                } else {
                    this.product_subitems = JSON.parse(this.$el.getAttribute('data-product-subitems'));
                }
            }

            if (canProceed) {
                if (this.product === 'voucher') {
                    this.originalPrice = this.input.cash;
                }

                Object.assign(data, {
                    product_type: this.product,
                    product_attributes: JSON.parse(this.$el.getAttribute('data-product-attributes')),
                    product_subitems: JSON.parse(this.$el.getAttribute('data-product-subitems')),
                    originalPrice: this.originalPrice,
                    term: input.terms,
                    cash_price: this.input.cash,
                    deposit: interest.deposit,
                    credit_amount: interest.total_amount_credit,
                    interest_amount: interest.interest_value,
                    payable_amount: interest.total_payable,
                    apr: interest.apr,
                    fixed_rate: interest.fixed_rate,
                    fixed_pa_rate: interest.pa_rate,
                    installment_amount: interest.installments,
                    final_installment_amount: interest.final_installment,
                });

                if (this.product === 'sofa') {
                    if (!this.swatchNotSelected && this.checkCombinations() > 0) {
                        var selectedCombination = [];

                        this.combinations.forEach((comb, index) => {
                            if (comb.qty > 0) {
                                selectedCombination.push(comb);
                            }
                        });

                        Object.assign(data, {
                            sofa_style: this.sofaSelection.style,
                            sofa_swatch: this.sofaSelection.swat,
                            sofa_combinations: selectedCombination,
                        });
                    } else {
                        if (this.swatchNotSelected) {
                            errors.push({message: 'Please choose a swatch.'});
                        }

                        if (this.checkCombinations() === 0) {
                            errors.push({message: 'Please choose a combination.'});
                        }

                        errors.forEach((error) => {
                            errorText += `<li>${error.message}</li>`;
                        });

                        this.$swal.fire({
                            title: 'Finish building your sofa',
                            html: `${errorText}`,
                            icon: 'error',
                            confirmButtonText: 'Continue',
                        });

                        return;
                    }
                }

                if (this.product === 'bed') {
                    if (this.checkBedConfig()) {
                        Object.assign(data, {
                            bed_bedBase: this.bedSelection.bedBase,
                            bed_storage: this.bedSelection.storage,
                            bed_mattress: this.bedSelection.mattress,
                            bed_headboard: this.bedSelection.headboard,
                            bed_swatch: this.bedSelection.swatch,
                        });
                    } else {
                        if (this.bedSelection.bedBaseNotSelected) {
                            errors.push({message: 'bed base'});
                        }

                        if (this.bedSelection.storageNotSelected) {
                            errors.push({message: 'storage'});
                        }

                        if (this.bedSelection.mattressNotSelected) {
                            errors.push({message: 'mattress'});
                        }

                        if (this.bedSelection.headboardNotSelected) {
                            errors.push({message: 'headboard'});
                        }

                        if (this.bedSelection.swatchNotSelected) {
                            errors.push({message: 'swatch'});
                        }

                        errors.forEach((error) => {
                            errorText += `<li>${error.message}</li>`;
                        });

                        this.$swal.fire({
                            title: 'Finish building your bed',
                            html: `${errorText}`,
                            icon: 'error',
                            confirmButtonText: 'Continue',
                        });

                        return;
                    }
                }

                if (this.product === 'blinds') {
                    axios.post(this.post_url, data).then(response => (
                        window.location.replace('/products/checkout/blinds')
                    )).catch(error => {
                    });

                    return;
                }

                if (this.product === 'car') {
                    axios.post(this.post_url, data).then(response => (
                        window.location.replace('/products/checkout/car')
                    )).catch(error => {
                    });

                    return;
                }

                axios.post(this.post_url, data).then(response => (
                    this.$swal.fire({
                        title: 'Item added to cart',
                        text: 'Your item has been added to your cart. Would you like to continue shopping?',
                        icon: 'success',
                        showCancelButton: true,
                        confirmButtonText: 'Continue Shopping',
                        cancelButtonText: 'Pay Outright or apply to Spread the Cost',
                        reverseButtons: true,
                        customClass: 'add-to-cart-alert',
                    }).then((result) => {
                        if (result.value) {
                            location.reload();
                        } else {
                            window.location.replace('/products/cart');
                        }
                    })
                )).catch(error => {
                });
            }
        },
        getData() {
            axios.post('/admin/api/sofabuilder/search', {product_id: this.product_id}).then(response => (
                this.styles = response.data.sofa.style,
                    this.combinations = response.data.sofa.combination,
                    this.combinations.forEach(combination => {
                        combination.qty       = 0;
                        combination.sub_total = 0;
                    })
            )).catch(error => {});

            axios.post('/admin/api/bedbuilder/search', {}).then(response => (
                this.baseTypes = response.data.bases
            )).catch(error => {});

            axios.post('/api/products/searchvoucher', {product_id: this.product_id}).then(response => (
                this.voucherPricing = response.data.voucherPricing
            )).catch(error => {});
        },
        selectSwatch(style, swatch) {
            this.sofaSelection.style  = style;
            this.sofaSelection.swatch = swatch;
            this.swatchNotSelected    = false;
        },
        incrementCombination(index) {
            if (this.combinations[index].qty < 20) {
                var newCombination = this.combinations[index];

                newCombination.qty       = Number(newCombination.qty) + 1;
                newCombination.sub_total = Number(newCombination.price) *
                                           newCombination.qty;
                this.$set(this.combinations, index, newCombination);

                // this.$forceUpdate();
            }
        },
        decrementCombination(index) {
            if (this.combinations[index].qty > 0) {
                var newCombination = this.combinations[index];

                newCombination.qty       = Number(newCombination.qty) - 1;
                newCombination.sub_total = Number(newCombination.price) *
                                           newCombination.qty;
                this.$set(this.combinations, index, newCombination);
            }
        },
        checkCombinations() {
            let qty = 0;

            this.combinationSelected = false;
            this.combinations.forEach(combination => {
                qty += Number(combination.qty);
            });

            if (qty > 0) {
                this.combinationSelected = true;
            }

            return qty;
        },
        selectItems(type, data, price = null) {
            switch (type) {
                case 'bedBase':
                    this.bedSelection.bedBase            = data;
                    this.bedSelection.bedBaseNotSelected = false;

                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.mattress, 'mattress');
                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.headboard, 'headboard');
                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.style, 'style');

                    this.bedSelection.bedBase.mattress.sort((a, b) => (+a.price > +b.price) ? 1 : -1)
                    break;

                case 'storage':
                    this.bedSelection.storage            = data;
                    this.bedSelection.storageNotSelected = false;
                    break;

                case 'mattress':
                    this.bedSelection.mattress            = data;
                    this.bedSelection.mattressNotSelected = false;
                    break;

                case 'headboard':
                    this.bedSelection.headboard            = data;
                    this.bedSelection.headboardNotSelected = false;
                    break;

                case 'swatch':
                    this.bedSelection.swatch            = data;
                    this.bedSelection.swatch.price      = price;
                    this.bedSelection.swatchNotSelected = false;
                    break;
            }
        },
        getItemPricing(baseId, baseItem, type) {
            for (let i in baseItem) {
                if (baseItem[i].prices.length) {
                    for (let j in baseItem[i].prices) {

                        if (baseId == baseItem[i].prices[j].base_id) {
                            baseItem[i].price = baseItem[i].prices[j].price;
                        }
                    }
                }
            }
        },
        resetBedBuilder() {
            this.bedSelection = {
                bedBaseNotSelected: true,
                bedBase: {},
                storageNotSelected: true,
                storage: {},
                mattressNotSelected: true,
                mattress: {},
                swatchNotSelected: true,
                swatch: {},
                headboardNotSelected: true,
                headboard: {},
            };
        },
        changeSelection(type) {
            switch (type) {
                case 'bedBase':
                    this.bedSelection.bedBaseNotSelected   = true;
                    this.bedSelection.bedBase              = {};
                    this.bedSelection.storageNotSelected   = true;
                    this.bedSelection.storage              = {};
                    this.bedSelection.mattressNotSelected  = true;
                    this.bedSelection.mattress             = {};
                    this.bedSelection.swatchNotSelected    = true;
                    this.bedSelection.swatch               = {};
                    this.bedSelection.headboardNotSelected = true;
                    this.bedSelection.headboard            = {};
                    break;

                case 'storage':
                    this.bedSelection.storageNotSelected   = true;
                    this.bedSelection.storage              = {};
                    this.bedSelection.mattressNotSelected  = true;
                    this.bedSelection.mattress             = {};
                    this.bedSelection.swatchNotSelected    = true;
                    this.bedSelection.swatch               = {};
                    this.bedSelection.headboardNotSelected = true;
                    this.bedSelection.headboard            = {};
                    break;

                case 'mattress':
                    this.bedSelection.mattressNotSelected  = true;
                    this.bedSelection.mattress             = {};
                    this.bedSelection.swatchNotSelected    = true;
                    this.bedSelection.swatch               = {};
                    this.bedSelection.headboardNotSelected = true;
                    this.bedSelection.headboard            = {};
                    break;


                case 'swatch':
                    this.bedSelection.swatchNotSelected    = true;
                    this.bedSelection.swatch               = {};
                    this.bedSelection.headboardNotSelected = true;
                    this.bedSelection.headboard            = {};
                    break;

                case 'headboard':
                    this.bedSelection.headboardNotSelected = true;
                    this.bedSelection.headboard            = {};
                    break;
            }
        },
        checkBedConfig() {
            let bed = this.bedSelection;

            return bed.bedBaseNotSelected === false && bed.bedBase !== {} &&
                   bed.storageNotSelected === false && bed.storage !== {} &&
                   bed.mattressNotSelected === false && bed.mattress !== {} &&
                   bed.headboardNotSelected === false && bed.headboard !== {} &&
                   bed.swatchNotSelected === false && bed.swatch !== {};
        },
    },
    computed: {
        interest() {
            var product = this.product;
            var final   = {
                total_value: 0,
                total_payable: 0,
                cumulative_interest: 0,
                installments: 0,
                final_installment: 0,
                pa_rate: 0,
                apr: 0,
                deposit: 0,
                total_amount_credit: 0,
                interest_value: 0,
                fixed_rate: 0,
                display_fixed_rate: product === 'voucher' ? 80 : 36,
                flat_rate: 0,
            };

            this.input.terms = parseInt(this.input.terms);
            if (this.input.cash != '') {
                this.input.cash = parseFloat(this.input.cash);
            }

            // Vouchers can only be in steps of 50
            if (product == 'voucher') {
                if (this.input.cash > 500) {
                    alert('Cannot finance more than 500 pounds');
                    this.input.cash = 500;
                } else if (this.input.cash < 50) {
                    this.input.cash = 50;
                }

                this.input.cash = Math.round(this.input.cash / 50) * 50;
            }

            final.deposit = this.calculate_deposit(product, this.input.cash);

            // Figure out the Flat Rate & Arrangement Fee
            this.calculate_loan_details(this.input.terms, product);

            this.input.cash_total     = this.input.cash + this.globals.arrangement_fee;
            final.total_amount_credit = this.input.cash + this.globals.arrangement_fee - final.deposit;
            final.fixed_rate          = this.globals.flat_rate;
            this.globals.flat_rate    = this.globals.flat_rate / 100;

            if (this.input.terms < 53) {
                final.interest_value = final.total_amount_credit * this.globals.flat_rate;
            } else {
                final.interest_value = final.total_amount_credit * (this.globals.flat_rate * (this.input.terms / 52));
            }

            final.total_value         = final.total_amount_credit + final.interest_value;
            final.total_payable       = final.total_value + final.deposit;
            final.cumulative_interest = final.interest_value / final.total_amount_credit;
            final.installments        = final.total_value / this.input.terms;

            // Check if we need to round up the pence and add onto the final payment
            if (final.installments != final.installments.toFixed(2)) {
                final.final_installment = (final.total_value - (final.installments.toFixed(2) * (this.input.terms - 1)));
            } else {
                final.final_installment = final.installments;
            }

            final.pa_rate = (((final.cumulative_interest) / (this.input.terms * 7)) * 365.25) * 100;
            final.apr     = this.calculate_apr(this.input.terms, this.globals.flat_rate) * 100;

            return final;
        },
        sofaTotals() {
            let total = {
                qty: 0,
                price: 0,
            };

            this.combinations.forEach(combination => {
                total.qty += Number(combination.qty);
                total.price += (Number(combination.price) * Number(combination.qty));
            });

            this.input.cash = total.price;

            return total;
        },
        bedTotals() {
            let total = 0;
            let b     = this.bedSelection;

            if (b.bedBase.price) {
                total += Number(b.bedBase.price);
            }

            if (b.storage.price) {
                total += Number(b.storage.price);
            }

            if (b.mattress.price) {
                total += Number(b.mattress.price);
            }

            if (b.headboard.price) {
                total += Number(b.headboard.price);
            }

            if (b.swatch.price) {
                total += Number(b.swatch.price);
            }

            this.input.cash = total;

            return total;
        },
    },
    mounted() {
        this.input.cash      = this.$el.getAttribute('data-product-price');
        this.product         = this.$el.getAttribute('data-product-type');
        this.post_url        = this.$el.getAttribute('data-post-url');
        this.product_id      = this.$el.getAttribute('data-product-id');
        this.stock_status_id = this.$el.getAttribute('data-stock_status_id');
        this.getTerms(this.product);

        if (this.product !== 'bed' && this.product !== 'sofa' && this.product !== 'voucher') {
            this.originalPrice      = this.$el.getAttribute('data-product-originalPrice');
            this.product_attributes = JSON.parse(this.$el.getAttribute('data-product-attributes'));
            this.product_subitems   = JSON.parse(this.$el.getAttribute('data-product-subitems'));
            let productAttributes   = Object.entries(this.product_attributes);
            let productSubitems     = Object.entries(this.product_subitems);

            productAttributes.forEach(attribute => {
                this.input.cash = Number(this.input.cash) + Number(attribute[1].price);
            });

            productSubitems.forEach(subitem => {
                this.input.cash = Number(this.input.cash) + Number(subitem[1].price);
            });
        }

        if (this.product === 'blinds') {
            this.input.cash = 0;
        }

        // if (this.product === 'voucher') {
        //     this.input.cash = this.$el.getAttribute('data-product-price');
        // }

        this.getData();
    },
});
